import { Link, useParams } from "react-router-dom";
import { usePortalSettingsData } from "store/slices/dashboardSlice";

/**
 * On the login page: a link to the cluster's quick checkout
 * (/:clusterId/quick-checkout), shown only when the portal settings say quick
 * checkout is switched on (account_settings.quick_checkout = 'Y'). Not shown
 * in the guest login pop-up of a payment page.
 */
const QuickCheckoutLoginLink = ({
  guestLogin = false,
  testId,
}: {
  guestLogin?: boolean;
  testId?: string;
}) => {
  const { clusterId: cluster_id } = useParams();
  const portalSettings: any = usePortalSettingsData();

  if (guestLogin || !cluster_id || portalSettings?.quick_checkout_enabled !== true) {
    return null;
  }

  return (
    <div className="flex items-center justify-center w-full">
      <Link
        to={`/${cluster_id}/quick-checkout`}
        className="cursor-pointer lg:text-base text-sm text-blue hover:!text-btnPrimaryHover font-medium leading-normal"
        data-testid={testId}
        aria-label="Quick Checkout"
      >
        Quick Checkout
      </Link>
    </div>
  );
};

export default QuickCheckoutLoginLink;
